import { render } from "./DashboardCallLogPage.vue?vue&type=template&id=09b6b345"
import script from "./DashboardCallLogPage.vue?vue&type=script&lang=js"
export * from "./DashboardCallLogPage.vue?vue&type=script&lang=js"

import "./DashboardCallLogPage.vue?vue&type=style&index=0&id=09b6b345&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__